/**
 * 处理富文本中的图片
 * @param {string} html 富文本HTML字符串
 * @param {function} processImageUrl 处理图片URL的函数
 * @returns {Promise<string>} 处理后的富文本HTML
 */
export async function processRichTextImages(html) {
  if (!html) return html;

  // 创建一个临时DOM元素来解析HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // 获取所有图片元素
  const images = tempDiv.querySelectorAll("img");

  // 如果没有图片，直接返回原HTML
  if (images.length === 0) return html;

  // 处理每张图片
  for (const img of images) {
    const originalSrc = img.getAttribute("src");
    if (!originalSrc) continue;

    try {
      // 处理图片URL
      const processedSrc = await processImageUrl(originalSrc);

      // 更新图片src
      img.setAttribute("src", processedSrc);

      // 可选：添加加载错误处理
      img.onerror = function () {
        this.style.display = "none";
      };
    } catch (error) {
      console.error("处理图片失败:", error);
      // 如果处理失败，可以选择移除图片或保持原样
      // img.remove();
    }
  }

  // 返回处理后的HTML
  return tempDiv.innerHTML;
}

/**
 * 处理图片链接
 */
const processImageUrl = async (url) => {
  console.log("url--------", url);

  const { ossHelper } = await import("./oss");
  if (!url?.includes("cn-hangzhou.aliyuncs.com")) {
    return url;
  }
  let urlPath = url.split("cn-hangzhou.aliyuncs.com/")[1].split("?")[0];
  let res = await ossHelper.getAuthOssUrl(urlPath);
  return res;
};

// 示例使用
const richTextHtml = `<div><p>这是一段富文本</p><OssImg src="https://example.com/image1.jpg" alt="图片1"><p>另一段内容</p><OssImg src="https://example.com/image2.jpg"></div>`;

// 示例图片处理函数 - 这里可以替换为实际的图片处理逻辑
async function exampleProcessImageUrl(originalUrl) {
  // 这里可以添加各种图片处理逻辑，例如：
  // 1. 添加CDN前缀
  // 2. 压缩图片URL
  // 3. 替换为缩略图版本
  // 4. 添加水印参数等

  console.log("处理图片URL:", originalUrl);

  // 模拟异步处理
  await new Promise((resolve) => setTimeout(resolve, 100));

  // 示例：简单地在URL后添加查询参数
  return `${originalUrl}?processed=true&width=800`;
}

// 使用示例
processRichTextImages(richTextHtml, exampleProcessImageUrl)
  .then((processedHtml) => {
    console.log("处理后的富文本:", processedHtml);
    // 这里可以将processedHtml插入到DOM或用于其他用途
  })
  .catch((error) => {
    console.error("处理富文本图片时出错:", error);
  });
